// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"WidgetsSection_wrapper__fPDfP"};